import * as React from 'react';

import { ListItem as SharedListItem } from '@hvcgroep/design-system';
import Closed from '@hvcgroep/design-system/assets/illustrations/Gesloten.svg';

import WasteStreamTeaser from '../../../../../shared/components/WasteStreamTeaser';

import { CalendarItem } from '../../../types';

import { formatDate } from '../../../../../shared/helpers/date';
import { useGetWasteStreamsQuery } from '../../../../../shared/store/slices/WebsiteApi';

const ListItem: React.FC<CalendarItem> = (props) => {
  const { data: wasteStreams } = useGetWasteStreamsQuery(null);

  const {
    type,
    date,
  } = props;

  switch (type) {
    case 'pickupMoment': {
      const { wasteStreamId } = props;

      return (
        <WasteStreamTeaser
          key={`${date}-${wasteStreamId}`}
          date={new Date(date)}
          wasteStreamId={wasteStreamId}
          title={wasteStreams?.[wasteStreamId].title}
          href={wasteStreams?.[wasteStreamId].path}
        />
      );
    }

    case 'holiday': {
      const { holiday } = props;

      return (
        <SharedListItem
          key={`${date}-${holiday}`}
          title={formatDate(new Date(date))}
          subtitle={holiday}
          icon={<img src={Closed} alt="" />}
        />
      );
    }

    default: {
      return null;
    }
  }
};

export default ListItem;
